import { render, staticRenderFns } from "./TeamDetails.vue?vue&type=template&id=72a24452&scoped=true&"
import script from "./TeamDetails.vue?vue&type=script&lang=js&"
export * from "./TeamDetails.vue?vue&type=script&lang=js&"
import style0 from "./TeamDetails.vue?vue&type=style&index=0&id=72a24452&lang=scss&scoped=true&"
import style1 from "./TeamDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a24452",
  null
  
)

export default component.exports